'use client'

import Link from 'next/link'
import { trackCtaClicked } from '../lib/analytics'

type CtaLocation = Parameters<typeof trackCtaClicked>[0]['cta_location']

export function TrackedLink({
  href,
  ctaText,
  ctaLocation,
  className,
  children,
}: {
  href: string
  ctaText: string
  ctaLocation: CtaLocation
  className?: string
  children: React.ReactNode
}) {
  return (
    <Link
      href={href}
      onClick={() =>
        trackCtaClicked({
          cta_text: ctaText,
          cta_location: ctaLocation,
          destination_url: href,
        })
      }
      className={className}
    >
      {children}
    </Link>
  )
}
